import { useState, useContext } from "react";
import {
  HStack,
  Box,
  Text,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Tooltip,
} from "@chakra-ui/react";
import { GiCardExchange } from "react-icons/gi"; // Exchange icon
import { formatAddress } from "../utils/formatMetamask";

import LogoutButton from "./wallet/LogoutButton";
import { AppContext } from "../AppContext";
import CopyToClipboardButton from "../utils/CopyToClipboardButton";
import WalletSelector from "./wallet/WalletSelector";

function ActiveContractInfo() {
  const { contractAddress, setContractAddress, contractName } = useContext(AppContext);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <HStack gap={1} p={0} justify="right">
      {/* Green dot for active status */}
      <Box w="12px" h="12px" borderRadius="50%" bg="green.600" display="inline-block" />

      {/* Contract Address */}
      <Text color="gray.700">{formatAddress(contractAddress)}</Text>
      <CopyToClipboardButton value={contractAddress} />

      <Text>|</Text>

      {/* Contract Name */}
      <Text>{contractName}</Text>

      {/* Change Wallet Icon Button with Tooltip */}
      <Tooltip label="Switch Account" fontSize="xs" fontFamily={'Sentinel'} hasArrow>
        <IconButton
          fontSize="16px"
          icon={<GiCardExchange />}
          size="xs"
          aria-label="Change Wallet"
          variant="unstyled"
          onClick={onOpen}
        />
      </Tooltip>

      {/* Modal for Wallet Selection */}
      <Modal  isOpen={isOpen} onClose={onClose} isCentered size="xs">
        <ModalOverlay />
        <ModalContent border='1px solid dodgerblue' borderRadius='xl' boxShadow='dark-lg'>
          <ModalHeader textAlign="center" fontSize="lg" fontWeight="bold" p={0}>
            <VStack
              //spacing={2}
              gap="auto"
              p={0}
              //mb={1}
              fontFamily={'Sentinel'}
              borderRadius="md"
              bg="gray.100"
              w="full"
              textAlign="center"
            >
              <Text fontSize="sm" fontWeight="bold" color="gray.600">
                Current:
              </Text>
              <Text fontSize="md" fontWeight="bold" color="blue.600">
                {contractName || "Unnamed Wallet"}
              </Text>
              <HStack gap='auto'>
              <Text fontSize="sm" color="gray.500">
                {formatAddress(contractAddress)}
              </Text>
              <CopyToClipboardButton value={contractAddress}/>
              </HStack>
              
            </VStack>
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody p={2}>
            {/* Wallet Selector Dropdown */}
            <WalletSelector
              onSelectWallet={(wallet) => {
                setContractAddress(wallet);
                onClose(); // Close modal after selection
              }}
            />
            <Text fontSize={'xs'}>* Select to change loaded account</Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </HStack>
  );
}

export default ActiveContractInfo;
